"use client"
import { LinkType, NavigationTypeOne } from "@/libs/types";
import clsx from "clsx";
import React from "react";
import LinkCustomized from "../../LinkCustomized";
interface MenuProps {
    locale: string
    navigation: NavigationTypeOne
}

const Menu: React.FC<MenuProps> = ({
    navigation = {},
    locale
}) => {

    const [show, setShow] = React.useState<boolean>(false)
    const handleCloseDropdown = () => setShow(false)

    return (
        <div className={clsx("menu-dropdown my-auto", navigation?.classes)}
            onMouseOver={() => setShow(true)}
            onMouseLeave={handleCloseDropdown}
        >
            <span className="cursor-pointer" onClick={handleCloseDropdown}>{navigation.name}</span>
            <div className={clsx("menu-linked bg-white rounded-bottom p-4", show ? "menu-toggle-on" : "")} onMouseLeave={handleCloseDropdown}>
                {navigation?.linked?.map((linked: LinkType, index: number) => {
                    return (
                        <LinkCustomized
                            locale={locale} linked={linked} className={clsx(index !== 0 ? "mt-2" : "")} key={index}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default Menu;